'use client';

import { useTranslation } from 'react-i18next';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import SolutionCustom from '@/components/apps/pages/solution/custom/SolutionCustom';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

export default function SolutionCustomPageClient() {
  const { t } = useTranslation('common');
  const title = t('커스텀 솔루션');

  return (
    <>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <SolutionCustom />
      </ResponsiveLayout>
    </>
  );
}
